<template>
    <div v-title="'和平精英-每日一题'" class="daily-question">
        <div class="panel-body">
            <!-- 背景图 -->
            <div class="head">
                <img src="~assets/ossweb-img/bac_01.png" onClick="return false">
                <img src="~assets/ossweb-img/bac_02.png" onClick="return false">
                <img src="~assets/ossweb-img/bac_03.png" onClick="return false">
                <img src="~assets/ossweb-img/bac_04.jpg" onClick="return false">
                <img src="~assets/ossweb-img/bac_05.png" onClick="return false">
                <img src="~assets/ossweb-img/bac_06.jpg" onClick="return false">
                <img src="~assets/ossweb-img/bac_07.png" onClick="return false">
                <img class="rule" src="~assets/ossweb-img/bac_08.png" onClick="return false">
            </div>
            <div class="content">
                <!-- 绑定按钮 -->
                <p class="rebind returntop">
                  <img id="not_bound" src="~assets/SignIn/ghbd.png" @click="rebind">
                </p>
                <!-- 抽到奖励弹框 -->

                <div class="info">
                    <!-- 转盘内容 -->
                    <div class="zp-box">
                        <div class="dp-box">
                            <ul class="rota" v-if="isShowRewardList">
                                <li v-for="(item, i) in rewardList" :key="i" :style="{transform: 'rotate('+ (360 - (i*perAngle - (90-perAngle)/2 - 6)) +'deg)'}">
                                    <div class="prize-name">{{item.package_name}}</div>
                                    <img :src="item.reward_image">
                                </li>
                                <!-- 不会抽中的第七个奖品 -->
                                <li :style="{transform: 'rotate('+ (360-(6*perAngle - (90-perAngle)/2 - 6)) +'deg)'}">
                                    <div class="prize-name">金币*108</div>
                                    <img src="~assets/ossweb-img/tu2.png">
                                </li>
                            </ul>
                            <img src="~assets/ossweb-img/dipan.png" class="rota">

                            <div class="zhizhen">
                                <img class="zhuan" src="~assets/ossweb-img/zhuan.png" @click="getReward">
                            </div>
                        </div>

                        <div class="zhongj-bb">
                            <div class="zhongj-bbl" id="colee" style="overflow:hidden;">
                                <div id="colee1"></div>
                                <div id="colee2"></div>
                            </div>
                            <div class="zhongj-bbr" id="coleer" style="overflow:hidden;">
                                <div id="coleer1"></div>
                                <div id="coleer2"></div>
                            </div>
                        </div>
                        <!-- end转盘内容 -->
                    </div>


                    <!--活动规则-->
                    <div class="rules">
                        <p>
                            <img src="~assets/ossweb-img/dian.png" onClick="return false">
                            关注《和平精英》手游官方微信公众号；
                        </p>
                        <p>
                            <img src="~assets/ossweb-img/dian.png" onClick="return false">
                            绑定微信账户并成功答对问题，可进入抽奖页面进行奖励抽取；
                        </p>
                        <p>
                            <img src="~assets/ossweb-img/dian.png" onClick="return false">
                            每个账号每天仅可抽奖一次，答题正确即可进行抽奖，100%有奖

                        </p>
                        <p>
                            <img src="~assets/ossweb-img/dian.png" onClick="return false"> 奖励直接发送至游戏邮箱，如遇到延迟未到账，请尝试重新登录领取。
                        </p>
                    </div>
                    <!-- /活动规则-->
                </div>

                <!-- 领取成功弹框 -->
                <div class="popup" id="sign_success">
                    <div class="mask close"></div>
                    <div class="event three">
                        <p class="close"><img style="top:0rem" src="~assets/ossweb-img/close.png" @click="toclose"></p>
                        <p class="title"><img src="~assets/ossweb-img/title4.png" onClick="return false"></p>
                        <p class="gif"><img :src="picurl" onClick="return false"></p>
                        <p class="text">{{text}}<br><span>赶紧点击进入游戏查收奖励！</span></p>
                        <a class="jr" href="https://gp.qq.com/d/index.html"><img src="~assets/SignIn/btn4.png"></a>
                    </div>
                </div>

                <!--已签到明天再来弹出框-->
                <div class="popup" id="failure">
                    <div class="mask close"></div>
                    <div class="event one">
                        <p class="close"><img src="~assets/ossweb-img/close.png" @click="toclose"></p>
                        <p class="title big"><img src="~assets/ossweb-img/title9.png"></p>
                        <p class="text"><span>温馨提示：签到有礼同样福利多多，别忘了参与~</span></p>
                    </div>
                </div>
                <!-- /弹出框-->

                <!--绑签弹框-->
                <div class="popup">
                    <div class="bindingContent"></div>
                </div>

                <!-- 横屏提示弹框 -->
                <div class="hpts">
                    <div class="shade"></div>
                    <div class="tishi">
                        <img src="~assets/ossweb-img/pm.png">
                        <p>为了更好的体验，请使用竖屏浏览</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import wxMethods from '@/utils/wxMethods'
  import mtaInitial from '@/utils/mtaInitial'
  import Http from '@/utils/Http'

  export default {
    data() {
      return {
        isBind: false,
        characName: '',
        bRotate: false,
        hasReward: false,
        text: '',
        picurl: '',
        // 奖品角度
        perAngle: 360/7,
        // 抽奖列表
        rewardList: [],
        // 是否展示抽奖列表
        isShowRewardList: false,
        gameTool: null,
      }
    },
    name: 'DailyQuestion',

    mixins: [wxMethods],

    created() {
      this.wxHideMenu()
      this.initRole()
      this.getRole()
      this.getGift()
    },

    mounted() {
      mtaInitial(
        process.env.VUE_APP_MTA_DAYLY_SID,
        process.env.VUE_APP_MTA_DAYLY_CID,
      )
    },

    methods: {
      initRole() {
        this.gameTool = new GameTools({
          game: 'cjm',
          allowPlatForm: ['wx'],
          loginType: 'wx',
        });
      },
      getRole() {
        this.gameTool.getRole(process.env.VUE_APP_GAME).then((res) => {
          this.loading = false
          if (res.hasRole) {
            this.isBind = true
            // this.checkReward()
          } else {
            const modal = new GameModal({
              gameTool: this.gameTool,
              game: process.env.VUE_APP_GAME,
              serverSelect: res.serverSelect,
              confirmText: ' ',
              showClose: true,
            })

            modal.show()

            modal.afterBind = (isBinded, characName) => {
              if (isBinded) {
                modal.hide()
                this.isBind = true
                alert('绑定成功！')
              } else {
                alert('绑定失败，请重试')
              }
            }

            modal.afterUnBind = (isUnBinded) => {
              if (isUnBinded) {
                modal.hide()
                this.isBind = false
                alert('解绑成功')
              } else {
                alert('解绑失败，请重试')
              }
            }
          }
        })
      },

      // 重新绑定角色
      rebind() {
        this.isClick = true;
        if (this.rebinding) return;
        this.rebinding = true;
        this.gameTool.getServerSelect(process.env.VUE_APP_GAME).then(serverSelect => {
          const modal = new GameModal({
            gameTool: this.gameTool,
            game: process.env.VUE_APP_GAME,
            serverSelect,
            confirmText: " ",
            showClose: true
          });

          modal.show();
          this.rebinding = false;
          this.isClick = false;

          modal.afterBind = isBinded => {
            if (isBinded) {
              this.isBind = true;
              modal.hide();
              $("#rebindingwin").show();
              alert('绑定成功！')
            } else {
              modal.hide();
              $("#no-information").show();
              this.hasgetRole = false;
              alert('绑定失败,请重试')
            }
          };

          modal.afterUnBind = (isUnBinded) => {
            if (isUnBinded) {
              modal.hide()
              this.isBind = false
              alert('解绑成功')
            } else {
              alert('解绑失败，请重试')
            }
          }
        });
      },

      /**
       * 查询抽奖资格接口
       */
      checkReward() {
        Http.post({
          path: 'daily_qa/reward/valid',
          params: {
            game: process.env.VUE_APP_GAME
          },
        })
          .then((res) => {
            console.info('success', res)
          })
          .catch((err) => {
            console.warn('error', err)
          })
      },

      // 获取奖品列表
      getGift(){
        Http.get({
          path: 'daily_qa/template/get',
          params: {
            site: 'cjm',
            game: process.env.VUE_APP_GAME
          }
        }).then(res => {
          let { result, code, msg } = res;
          if(code===200){
            this.rewardList = result.rewards;
            this.isShowRewardList = true;
          }else if(msg){
            alert(msg)
          }
        }).catch(error => {
          if(error.msg) alert(error.msg);
        })
      },

      // 初始化转盘
      rotateFunc(awards, angles, text) {
        if (this.playing) return
        this.playing = true
        this.bRotate = !this.bRotate
        $('.rota').stopRotate()
        $('.rota').rotate({
          angle: 0,
          animateTo: angles + 1440,
          duration: 3000,
          callback: () => {
            this.bRotate = !this.bRotate
            const shun = awards - 1
            this.text = text
            $('#sign_success').addClass('active')
            $('.rota li').addClass('active')
            $('.rota li').eq(shun).addClass('chouzhong')
            this.playing = false
          },
        })
      },

      // 抽奖接口
      reward() {
        Http.post({
          path: 'daily_qa/reward/get',
          params: {
            game: process.env.VUE_APP_GAME,
          },
        })
          .then((res) => {
            this.loading = false
            if (res.code == 200) {
              this.rwLists(res.result.package_id)
            } else {
              alert(res.msg)
            }
          })
          .catch((err) => {
            this.loading = false
            alert(err.msg)
          })
      },

      getReward() {
        if (this.loading || this.playing || !this.isShowRewardList) return
        this.loading = true
        this.isBind ? this.reward() : this.getRole()
      },

      toclose() {
        $('.popup').hide()
      },

      // 奖品列表
      rwLists(rwId) {
        // 没有对应的奖品
        let noCurrentPrize = true

        this.rewardList.forEach((item, index) => {
          if(item.package_id == rwId){
            noCurrentPrize = false
            this.rotateFunc(index+1, ((index+1)*this.perAngle - (90-this.perAngle)/2 - 6) - 50, item.package_name)
            this.picurl = item.reward_image
          }
        });

        if(noCurrentPrize){
          alert('未找到匹配的礼包')
        }
      },
    },
  }
</script>

<style src="./DailyQuestion.scss" lang="scss"></style>
